import React from 'react'
import { useIntl } from 'src/common/razzle-platform-translate'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme, makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiDialogContent-root': {
        padding: '0 !important'
      },
      '& .MuiDialogActions-root': {
        paddingTop: 15,
        paddingBottom: 15,
        marginRight: 15,
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        }
      }
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
}))

export function ReservationDialog({ children, reservationButton: ReservationButton }) {
    const [open, setOpen] = React.useState(false)
    const theme = useTheme()
    const { formatMessage } = useIntl()
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
    const classes = useStyles()

    const handleClickOpen = () => {        
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <>
            <ReservationButton
                onClick={handleClickOpen}
                isDisabled={open}
                label={formatMessage({ id: 'Réserver maintenant', defaultMessage: 'Réserver maintenant' })}
            />
            <Dialog fullScreen={fullScreen} className={classes.root} style={{ zIndex: 12999 }} fullWidth={true} maxWidth="md" open={open} onClose={handleClose} aria-labelledby="reservation dialog">
                { children({ onClose: handleClose, ContentContainer: DialogContent, ActionsButtonsContainer: DialogActions }) }
            </Dialog>
        </>
    )
}